import { Component } from '@angular/core';

@Component({
  selector: 'app-certificazione-competenze',
  templateUrl: './certificazione-competenze.component.html',
  styleUrls: ['./certificazione-competenze.component.scss']
})
export class CertificazioneCompetenzeComponent {

}
